import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import { VueMarqueeSlider } from 'vue3-marquee-slider';
    import { FinanceCompanies } from 'src/const/finance-companies';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LenderSlider',
  setup(__props) {

    //@ts-ignore
    function logo(financeCompanyId: number){
        let logo = FinanceCompanies.find(f => f.financeCompanyId === financeCompanyId)?.logo;
        if(logo ){
            return require('assets/logos/'+logo);
        }
        return null;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueMarqueeSlider), {
    id: "marqee-slider",
    width: 250,
    speed: 15000,
    space: 50
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: logo(50),
        alt: "Alphera",
        class: "",
        "aspect-ratio": "1",
        style: {"filter":"grayscale(1)"}
      }, null, 8, _hoisted_1),
      _createElementVNode("img", {
        src: logo(66),
        alt: "V12",
        "aspect-ratio": "1",
        class: "",
        style: {"filter":"grayscale(1)"}
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        src: logo(67),
        alt: "Motonovo",
        class: "",
        "aspect-ratio": "1",
        style: {"filter":"grayscale(1)"}
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        src: logo(70),
        alt: "Close Brothers",
        class: "",
        style: {"filter":"grayscale(1)"}
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        src: logo(73),
        alt: "Zopa",
        "aspect-ratio": "1",
        class: "",
        style: {"filter":"grayscale(1)"}
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        src: logo(74),
        alt: "Credit Agricole",
        class: "",
        "aspect-ratio": "1",
        style: {"filter":"grayscale(1)"}
      }, null, 8, _hoisted_6),
      _createElementVNode("img", {
        src: logo(75),
        alt: "Northridge",
        class: "",
        "aspect-ratio": "1",
        style: {"filter":"grayscale(1)"}
      }, null, 8, _hoisted_7)
    ]),
    _: 1
  }))
}
}

})